import { useMutation, UseMutationOptions } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { contactsApi } from 'src/Services/API';
import { TempUploadedImageDto } from 'src/Services/API/generated';

export const useUploadContactProfileImage = (
  options?: UseMutationOptions<TempUploadedImageDto, unknown, File>
) => {
  const assetId = useCurrentAssetId();

  return useMutation<TempUploadedImageDto, unknown, File>(
    'upload-contact-profile-image',
    async (file: File) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }

      const response = await contactsApi.contactsControllerUploadTemporaryImage(assetId, file);
      return response.data;
    },
    options
  );
};
